import React, { useState, useEffect } from "react";
import { Redirect, Route, Link } from "react-router-dom";

import api from "../services/api";

export default function Landing(props) {
  const [pageContent, setPageContent] = useState("");
  const getContentPage = async () => {
    var response = await api.get("/get-content-page", {
      page_uid: "responsible_gaming",
    });

    if (response.status == 200) {
      setPageContent(response.data);
    }
  };

  useEffect(() => {
    getContentPage();
  }, []);
  const renderHTML = (rawHTML: string) =>
    React.createElement("div", {
      dangerouslySetInnerHTML: { __html: rawHTML },
    });

  return (
    <>
      <div class="container-xxl">
        <section className="contentPage">
          <div className="pageTitle">
            {pageContent && pageContent.content_data.page_title}
          </div>
          <div className="paragraph">
            {pageContent && renderHTML(pageContent.content_data.content)}
          </div>
        </section>

        <section className="contentPage d-none">
          <div className="pageTitle">
            <h1>Responsible Gaming</h1>
          </div>
          <div className="paragraph">
            <p>
              <strong>Last updated:</strong> March 03, 2025
            </p>

            <h2>Introduction</h2>
            <p>Please read this information carefully for your own benefit.</p>
            <p>
              The Website{" "}
              <a href="http://www.chilirojo.com">www.chilirojo.com</a>{" "}
              ("Casino", "Website", “Company”, "We", "Us", "Our") is owned and
              operated by ChapChap Technologies Ltd, a limited liability company
              registered in Island of Anjouan, Comoros with company registration
              number 15788, with registered address at Hamchako Mutsamudu, The
              Autonomous Island of Anjouan, Union of Comoros. chilirojo is
              licensed in the State of Anjouan under the Computer Gaming
              Licensing Act 007 of 2005 under License No. ALSI-202409025-FI2.
            </p>

            <h2>Interpretation and Definitions</h2>
            <h3>Interpretation</h3>
            <p>
              The words of which the initial letter is capitalized have meanings
              defined under the following conditions. The following definitions
              shall have the same meaning regardless of whether they appear in
              singular or in plural.
            </p>

            <h3>Definitions</h3>
            <p>For the purposes of these Terms and Conditions:</p>
            <ul>
              <li>
                <strong>Account</strong> means a unique account created for You
                to access our Service or parts of our Service.
              </li>
              <li>
                <strong>Company</strong> (referred to as either "the Company",
                "We", "Us" or "Our" in this Agreement) refers to chilirojo.com.
              </li>
              <li>
                <strong>Service</strong> refers to the Website.
              </li>
              <li>
                <strong>Website</strong> refers to chilirojo.com.
              </li>
              <li>
                <strong>You</strong> means the individual accessing or using the
                Service, or the company, or other legal entity on behalf of
                which such individual is accessing or using the Service, as
                applicable.
              </li>
            </ul>

            <h2>Responsible Gambling and Self Exclusion</h2>
            <p>
              Gambling means for the majority of our Users, entertainment, fun
              and excitement. But we also know that for some of our Users
              gambling has negative side effects. In medical science,
              pathological gambling has been recognized as a serious illness for
              many years.
            </p>
            <p>
              Since our first day, we have thought about this problem and tried
              our best to help. Under “Responsible Gambling,” we understand
              multiple steps of measures with which a gambling provider can help
              to lower the possibility of negative side effects appearing. In
              case they already appear, we also try to take active steps against
              them.
            </p>
            <p>
              The most important instrument against negative side effects from
              gambling is knowledge and education about the risks of gambling to
              support our Users' self-control and ensure they do not suffer from
              negative side effects.
            </p>

            <h2>Information and Contact</h2>
            <p>
              Our Support will help you via email at all times without any
              additional costs for you:
            </p>
            <p>
              <strong>Email:</strong>{" "}
              <a href="mailto:support@chilirojo.com">support@chilirojo.com</a>
            </p>
            <p>
              Our Support will, of course, not give out any information about
              You without Your consent to anyone else.
            </p>
            <p>
              In addition, you can also take a self-test to see if you are
              already gambling addicted at:
            </p>
            <p>
              <a href="https://www.begambleaware.org/gambling-problems/do-i-have-a-gambling-problem/">
                https://www.begambleaware.org/gambling-problems/do-i-have-a-gambling-problem/
              </a>
            </p>
            <p>
              You can also find additional information about gambling addictions
              at:
            </p>
            <p>
              <a href="https://www.begambleaware.org/safer-gambling/">
                https://www.begambleaware.org/safer-gambling/
              </a>
            </p>

            <h2>Helpful Hints for Responsible Gambling at chilirojo.com</h2>
            <p>
              We recommend you think about the following hints before gambling
              to ensure gambling stays fun for You and without any negative side
              effects:
            </p>
            <ul>
              <li>
                <strong>Set yourself a deposit limit:</strong> Before you start
                gambling, think about how much you can afford to gamble with
                according to Your financial situation. Play with amounts that
                are for fun and for Your entertainment.
              </li>
              <li>
                <strong>Do not try to win back a loss at any cost:</strong> Try
                not to take huge risks to win back what You lost before at any
                cost. Play for entertainment and not to earn money.
              </li>
              <li>
                <strong>Set yourself a time limit:</strong> Set yourself a time
                limit and do not break it. Keep in mind gambling should stay in
                balance with your other hobbies and not be Your only hobby.
              </li>
              <li>
                <strong>Play smart:</strong> It is smarter not to play when You
                are extremely stressed, depressed, or under too much pressure.
                Also, do not play when you are under the influence of
                medications, drugs, or alcohol.
              </li>
              <li>
                <strong>Take breaks:</strong> You should take breaks when You
                notice that You are getting tired or can’t concentrate anymore.
              </li>
              <li>
                <strong>Only one account:</strong> To make it easier to have an
                overview of how much time and money You spend on gambling, it is
                highly advised not to create more than one Account per Person.
              </li>
            </ul>

            <h2>Minor Protection</h2>
            <p>
              To use our Service, You have to be 18 years or older. To avoid
              abuse, keep Your login data safe from any minors near You.
            </p>
            <p>
              Principally, we recommend a filter program to avoid minors,
              especially children, from accessing any content on the internet
              that is not healthy for them.
            </p>
            <p>
              For parents, we can recommend a list of internet filters to
              support them in keeping their children away from any content that
              was not made for them:
            </p>
            <p>
              <a href="https://famisafe.wondershare.com/internet-filter/best-internet-filters.html">
                https://famisafe.wondershare.com/internet-filter/best-internet-filters.html
              </a>
            </p>

            <h2>Self-Exclusion</h2>
            <p>
              In case You are diagnosed with a gambling addiction or try to stay
              away from gambling for a different reason, we want to assist you
              in staying away from anything that does nothing good for you.
              “Self-Exclusion” means that You exclude yourself, out of Your own
              choice, from all gambling services. This exclusion cannot be
              undone for a set amount of time.
            </p>
            <p>
              If you wish to self-exclude yourself from gambling, please message
              our support and give them a time span between 6 months and 5
              years. They will also explain all future steps and what is needed
              from you.
            </p>
            <p>
              <strong>Email:</strong>{" "}
              <a href="mailto:support@chilirojo.com">support@chilirojo.com</a>
            </p>
            <p>
              Please keep in mind that Self-Exclusion is permanent for the set
              time span and will not be undone for your own protection.
            </p>
            <p>
              During Self-Exclusion, you are not allowed to create a new
              Account, and every attempt to create a new Account during
              Self-Exclusion is a violation of our Terms of Service and may
              result in the permanent ban of your original account.
            </p>
          </div>
        </section>
      </div>
    </>
  );
}
